"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpertiseLevel = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.ExpertiseLevel = {
  name: 'ExpertiseLevel',
  type: 'taxonomy',
  autoRoutes: ['create', 'update', 'list'],
  select: {
    queryFields: "orderNumber description { id text }",
    filterArgs: "orderBy: { fieldName: \"orderNumber\" }",
    orderBy: {
      fieldName: 'orderNumber'
    }
  },
  form: {
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      orderNumber: {
        type: 'int'
      },
      promptLabel: {
        type: 'text',
        description: "Specify a label to use when this is used in a sentence like 'Are you [Prompt Label] in any of these topics'? E.g., 'Interested' might use a prompt label 'interested', but 'Thought Leader' might be 'a thought leader'."
      },
      description: {
        type: 'longText'
      }
    })
  }
};